import React from 'react';

import {
    formatEventDate,
    formatEventTime
} from '$utilities/format.js';

import { Image } from '$partials/media/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/ui.d.ts').EventCard}
 */
const EventCard = ({
    event,
    isWide = false,
    timezone
}) => {
    const date = formatEventDate(event, timezone);
    const time = formatEventTime(event, timezone);

    return (
        <div className='expand-interaction'>
            {event?.listingImage && (
                <figure className='mb-8 text-[0] leading-[0] tracking-normal'>
                    <div className='pointer-events-none select-none'>
                        <Image {...event.listingImage} />
                    </div>
                </figure>
            )}

            <div className={isWide ? 'flex flex-col' : undefined}>
                <div className={isWide ? 'w-full sm:w-1/2 sm:pr-16' : undefined}>
                    <h3 className='type-style-body-bold'>
                        <a
                            className='expand-interaction__action'
                            href={event?.url}>{event?.title}</a>
                    </h3>

                    {event?.listingText && (
                        <p className='type-style-body'>{event.listingText}</p>
                    )}
                </div>

                <div className={isWide ? 'w-full sm:w-1/2 mt-4 sm:mt-0' : undefined}>
                    {date && (
                        <p className='type-style-body'>{date}</p>
                    )}

                    {time && (
                        <p className='type-style-body'>{time}</p>
                    )}

                    {event?.studio?.title && (
                        <p className='type-style-body'>{event.studio.title}</p>
                    )}
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default EventCard;
